import React from "react";
import "./App.css";
import { usePrivy } from "@privy-io/react-auth";

function App() {
    const { login, logout, authenticated, user } = usePrivy();

    return (
        <div className="App">
            <div className="header-container">
                <img
                    src={`${process.env.PUBLIC_URL}/BannerBia.png`}
                    alt="Landing Page Header"
                    style={{ width: "100%" }}
                />
            </div>

            <div className="content-container">
                <div className="blur-box">
                    {!authenticated ? (
                        <>
                            <h2>Félicitations, Vous Êtes sur le Point de Débloquer Votre Badge Unique ! 🌊✨</h2>
                            <p>Vous avez complété les trois grandes quêtes de La Vague :</p>
                            <ul>
                                <p>✔ Votre Diagnostic Solaire ☀️</p>
                                <p>✔ Le Grand Quiz Océan & Protection 🌿</p>
                                <p>✔ Votre Profil Engagé 🔍</p>
                            </ul>
                            <p>Votre engagement mérite une récompense unique et éternelle.</p>
                            <h3>🌟 Recevez dès maintenant votre Badge La Vague  ! 🌟</h3>
                            <p><strong>💡 Qu’est-ce que ce badge ?</strong></p>
                            <p>Ce n’est pas un simple badge… C’est une clé numérique immuable, enregistrée grâce à la technologie blockchain. Il atteste de votre engagement et vous ouvre un accès exclusif à vie à des avantages réservés aux membres d’élite des Laboratoires de Biarritz.</p>
                            <p>Il atteste de votre engagement et vous ouvre <strong>un accès exclusif à vie</strong> à <strong>des avantages</strong> des Laboratoires de Biarritz.</p>
                            <button className="connect" style={{ background: "white", color: "black" }} onClick={login}>
                                Je Récupère Mon Badge
                            </button>
                        </>
                    ) : (
                        <>
                            <h2>Vous avez débloqué votre badge, il vous sera communiqué par mail par les Laboratoires de Biarritz !  🌊</h2>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;
